// Event handler for the "CHANGE" buttons -> go into edit mode
document.querySelectorAll('.copy-address-button').forEach(function(cb) {
    cb.addEventListener('click', function(event) {
        event.preventDefault();
        var b = event.target;
        const p = b.closest('fieldset');
        const target = p.dataset['prefix'];
        [
            'first_name',
            'last_name',
            'company',
            'company_url',
            'email',
            'vat_number',
            'address1',
            'address2',
            'city',
            'state',
            'zip_code',
            'country'
        ].forEach((field_name) => {
            console.log(target + '-' + field_name)
            document.getElementById(target + '-' + field_name).value =
                window.config.personalAddress[field_name]
        });
    });
});
